import { useState, useEffect } from "react";
import {
  RangeSlider,
  RangeSliderTrack,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  Box,
  Text,
} from "@chakra-ui/react";
import { roundUp } from "utils/helpers";

interface Props {
  range: any[];
  onChangeEnd: (value: any[]) => void;
  labelTextPrefix?: string;
  defaultValue?: any[];
  displayMaxAsUnlimited?: boolean;
}

export function DynamicRangeSlider({
  labelTextPrefix,
  range,
  defaultValue = [range[0], range[1]],
  displayMaxAsUnlimited = false,
  onChangeEnd = () => {},
}: Props) {
  const [value, setValue] = useState<number[]>([0, 1]);
  const [displayValues, setDisplayValues] = useState<any[]>(defaultValue);

  useEffect(() => {
    const firstMapping = range.findIndex((value) => value === defaultValue[0]);
    const secondMapping = range.findIndex((value) => value === defaultValue[1]);
    setValue([firstMapping, secondMapping]);
  }, []);

  const handleOnChange = ([first, second]: number[]) => {
    const selectedRange = [range[first], range[second]];
    setDisplayValues(selectedRange);
    setValue([first, second]);
  };

  const handleOnChangeEnd = ([first, second]: number[]) => {
    const selectedRange = [range[first], range[second]];
    onChangeEnd(selectedRange);
  };

  const max = range?.length - 1;

  return (
    <Box>
      <RangeSlider
        aria-label={["min", "max"]}
        max={max}
        min={0}
        step={1}
        value={value}
        onChange={handleOnChange}
        onChangeEnd={handleOnChangeEnd}
      >
        <RangeSliderTrack>
          <RangeSliderFilledTrack />
        </RangeSliderTrack>
        <RangeSliderThumb index={0} />
        <RangeSliderThumb index={1} />
      </RangeSlider>
      <Text mt="2">
        {displayMaxAsUnlimited && value[0] === max
          ? "unlimited"
          : roundUp(displayValues[0], 0)}{" "}
        -{" "}
        {displayMaxAsUnlimited && value[1] === max
          ? "unlimited"
          : roundUp(displayValues[1], 0)}{" "}
        {labelTextPrefix}
      </Text>
    </Box>
  );
}
